<template>
  <div>
    <h1>Moveds</h1>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="articlemoveds"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.articleid }}</td>
          <td>{{ props.item.oldname }}</td>
          <td>{{ props.item.path }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Moveds",
  metaInfo() {
    return {
      title: "Moveds",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      articlemoveds: [],
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Article",
          value: "articleid"
        },
        {
          text: "Old name",
          value: "oldname"
        },
        {
          text: "Path",
          value: "path"
        }
      ],
      pagination: {
        rowsPerPage: -1
      }
    };
  },
  methods: {
    fetchArticleMoveds() {
      nbmlaw.get(`/cors/admin/extras/articles/moved`).then(response => {
        // console.log(response.data)
        this.articlemoveds = response.data;
      });
    }
  },
  created() {
    this.fetchArticleMoveds();
  }
};
</script>
